import { formatFileSize, Loading, mainColors } from '@avantstay/backoffice-core'
import { IconDownload, IconPaperclip } from '@avantstay/backoffice-vectors'

import { GuestInboxTimelineAttachment } from '@new/domains/operations/components/StayTimeline/StayTimeline.types'

import { AttachmentKind, getAttachmentName } from '../../MessageAttachments.utils'
import { DownloadButton } from '../DownloadButton'
import * as S from './AttachmentItem.styles'

interface AttachmentItemProps {
  attachment: GuestInboxTimelineAttachment
  kind: AttachmentKind
  src: string
  isDownloading: boolean
  onOpen: () => void
  onDownload: () => void
  onLoadError: () => void
}

export const AttachmentItem = ({
  attachment,
  kind,
  src,
  isDownloading,
  onOpen,
  onDownload,
  onLoadError,
}: AttachmentItemProps) => {
  const name = getAttachmentName(attachment)

  if (kind === 'file') {
    return (
      <S.FileChip type="button" onClick={onDownload}>
        <IconPaperclip />
        <S.FileName as="span" color={mainColors.primaryMedium}>
          {name}
        </S.FileName>

        {attachment.size ? (
          <S.FileSize as="span" color={mainColors.neutralExtremelyDark}>
            {formatFileSize(attachment.size)}
          </S.FileSize>
        ) : null}

        <S.FileAction>{isDownloading ? <Loading size="4px" /> : <IconDownload />}</S.FileAction>
      </S.FileChip>
    )
  }

  return (
    <S.Media>
      {kind === 'image' ? (
        <S.Tile type="button" onClick={onOpen}>
          <S.Thumb
            src={src}
            alt={name}
            loading="lazy"
            width={120}
            height={120}
            onError={onLoadError}
          />
        </S.Tile>
      ) : (
        <S.Video controls preload="metadata" src={src} onError={onLoadError} />
      )}

      <S.MediaAction>
        <DownloadButton isDownloading={isDownloading} onDownload={onDownload} />
      </S.MediaAction>
    </S.Media>
  )
}
